/**
 * 攒车这一档的家什。
 *
 * 只有一件真家伙：车铺地沟上那副吊架，手稳不稳跟它直接相关。
 */

export const VEHICLE_BENCH_PROPS = {
  assembly_bench: {
    name: '车铺工位', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'assemble', label: '车铺工位', hint: 'E 攒车' },
    desc: '一副铁吊架加一条地沟，扳手按大小排成一溜。',
    state: {},
  },
};
